<template>
  <div class="text">
    <h4 class="fw-bold">Data protection</h4>
    <h5 class="fw-bold mt-5">I. Contact</h5>
    <p>These instructions apply to data processing by:</p>
    <ul>
      <li>M.E.D.U.Z.Z.A.</li>
      <li>Mönchhofallee 1</li>
      <li>D-65451 Kelsterbach Germany</li>
    </ul>
    <p>
      For questions about data protection, you can also contact our Data
      Protection Officer directly.
    </p>
    <h5 class="fw-bold mt-5">
      II. Processing of personal data; nature and purpose
    </h5>
    <p class="fw-bold mt-5">1. Web hosting</p>
    <p>
      We use the e-commerce solution "salesforce Commerce Cloud" for the
      provision and operation of our website. The provider of salesforce
      Commerce Cloud is salesforce.com inc., 415 Mission Street, 3rd Floor, San
      Francisco CA 64105, USA (hereinafter referred to as "salesforce"). In the
      context of this agreement, this website is hosted on salesforce's servers.
    </p>
    <p>
      In connection with hosting and maintaining the website, salesforce
      processes personal information on our behalf that arises from the
      following actions by the user:
    </p>
    <ul>
      <li>visiting the website;</li>
      <li>ordering as a guest;</li>
      <li>placing an order as an existing customer;</li>
      <li>creating a customer account;</li>
    </ul>
    <p>
      We have contractually ensured that this data is hosted by Salesforce on
      servers located in the European Union. The servers are located in France.
    </p>
    <p>
      With respect to the data processing that takes place in the context of the
      hosting of our website, we have entered into a "Data Processing Addendum
      (DPA)" with Salesforce. This DPA includes the "EU Standard Contractual
      Clauses" (Art. 46(2)(c) of the GDPR). Through this contract, Salesforce
      assures that the data is processed at our direction and in accordance with
      the requirements of the GDPR. In addition, Salesforce has implemented
      "Binding Corporate Rules" for compliance with data protection.
    </p>
    <p>
      The commissioning of salesforce and the associated data processing are
      based on our legitimate interest (Art. 6(1)(f), GDPR) in making our
      offering available on this website and in entrusting a professional
      service provider with high security standards for this provision.
    </p>
    <p class="fw-bold mt-5">2. When visiting our website</p>
    <p>
      When you visit our website https://www.meduzza.de, the browser used on
      your device automatically sends information to the server of our website.
      This information is temporarily stored in a so-called log file. The
      following information is collected and stored without your intervention
      and deleted from the log files after 90 days:
    </p>
    <ul>
      <li>IP address of the requesting computer,</li>
      <li>date and time of access,</li>
      <li>name and URL of the retrieved file,</li>
      <li>website from which the access takes place (referrer URL),</li>
      <li>operating system of the requesting computer,</li>
    </ul>
    <p>
      browser type and version and other information transmitted by the browser
      (such as your computer's operating system),
    </p>
    <p>
      The legal basis for the data processing is Art. 6(1)(f) of the GDPR. Our
      legitimate interest follows from the above listed purposes of data
      processing. In the event of an attack on our network infrastructure, we
      will evaluate your IP address to assert or defend legal claims.
      Furthermore, we use cookies and analysis services when you visit our
      website. You will find more detailed explanations on this under points IV
      and V of this data-protection statement.
    </p>
    <p class="fw-bold mt-5">3. In the context of an order in our online shop</p>
    <p>
      If you wish to order products via our website as a guest or as a
      registered customer, we process the following mandatory information:
    </p>
    <ul>
      <li>salutation, first name, last name,</li>
      <li>a valid email address,</li>
      <li>invoice and delivery address</li>
      <li>
        depending on the payment method you have selected, payment data (such as
        bank details)
      </li>
    </ul>
    <p>
      The data processing is carried out at your request and is required in
      accordance with Art. 6(1)(b) and (f) of the GDPR for the purposes
      mentioned for the fulfilment of the contract and for other pre-contractual
      measures as well as for our legitimate interests.
    </p>
    <p>
      The personal data processed by us for the order will be stored until the
      expiry of the statutory warranty period and automatically deleted
      thereafter, unless we are obliged to store the data for a longer period of
      time in accordance with Art. 6(1)(c) of the GDPR due to storage and
      documentation obligations pursuant to tax and commercial law (from the
      German Commercial Code (HGB), German Penal Code (StGB) or German Tax Code
      (AO)) or you have consented to storage beyond this in accordance with Art.
      6(1)(a) of the GDPR.
    </p>
    <p class="fw-bold mt-5">4. When creating a customer account</p>
    <p>
      We offer you the possibility to create a customer account with us. For the
      registration and the creation of the customer account we need the
      following mandatory information:
    </p>
    <ul>
      <li>salutation, first name, last name,</li>
      <li>a valid email address,</li>
      <li>invoice and delivery address</li>
      <li>password</li>
    </ul>
    <p>
      We work with Emarsys eMarketing Systems AG Hans-Fischer-Straße 10, 80339
      Munich, Germany (hereinafter referred to as "Emarsys") as a specialised
      service provider for Customer Relation Management for documentation,
      administration and marketing purposes, to whom we transfer your data
      (email address, first name, last name, gender, purchase history, postal
      address). This service provider has been selected and commissioned by us,
      is bound by our instructions and is regularly inspected, particularly with
      regard to the appropriate technical and organisational measures for data
      security. Data will not be transferred to non-EEA countries.
    </p>
    <p>
      The data processing is carried out at your request and is required in
      accordance with Art. 6(1)(b) and (f) of the GDPR for the purposes
      mentioned for the fulfilment of the contract and for other pre-contractual
      measures as well as on the basis of our legitimate interests.
    </p>
    <p>
      The personal data processed by us for the order will be stored until the
      expiry of the statutory warranty period and automatically deleted
      thereafter, unless we are obliged to store the data for a longer period of
      time in accordance with Art. 6(1)(c) of the GDPR due to storage and
      documentation obligations pursuant to tax and commercial law (from the
      German Commercial Code (HGB), German Penal Code (StGB) or German Tax Code
      (AO)) or you have consented to storage beyond this in accordance with Art.
      6(1)(a) of the GDPR.
    </p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.text {
  margin: 100px 150px 60px 25px;
  text-align: start;
}
@media (max-width: 576px) {
  .text {
    font-size: 12px;
    width: 80%;
    margin-top: 120px;
  }
}
</style>
